import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CounterState } from 'domain/entities/NotifyEntity';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';

const initialState: CounterState = {
    key: PRIVATE_ROUTES.SUB.CU_022_01,
    value: 0,
    reCount: false,
    needReload: false,
    connected: false,
};

export const notifyCounterSlice = createSlice({
    name: 'notifyCounterSlice',
    initialState,
    reducers: {
        setUnreadNotifyCount: (state, action: PayloadAction<number>) => {
            if (state.connected) {
                return {
                    ...state,
                    value: action.payload,
                    reCount: false,
                };
            }
        },
        reCountNotify: (state) => {
            if (state.connected) {
                state.reCount = true;
            }
        },
        setNotifyConnectSocket: (state) => {
            return {
                ...state,
                connected: true,
                reCount: true,
            };
        },
        resetNotifyCount: () => {
            return initialState;
        },
    },
});

export const { setUnreadNotifyCount, reCountNotify, resetNotifyCount, setNotifyConnectSocket } =
    notifyCounterSlice.actions;

export default notifyCounterSlice.reducer;
